import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-order-name',
  templateUrl: './add-order-name.component.html',
  styleUrl: './add-order-name.component.scss'
})
export class AddOrderNameComponent {
  formErrors: string[] = [];

  constructor(private dialogRef: MatDialogRef<AddOrderNameComponent>, private translate: TranslateService) { }

  Confirmation(form?: any) {
    this.formErrors = [];
    const errors = [];
    let isNotValid = false;
    if (!form.orderName) {
      errors.push('EnterOrderName');
      isNotValid = true;
    }

    if (isNotValid) {
      errors.forEach(item => {
        this.formErrors.push(this.translate.instant(item));
      });

      return;
    }

    this.dialogRef.close({ data: form.orderName });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
